export default "__VITE_ASSET__BMlyx4yf__"